import React from 'react';
import { Lightbulb } from 'lucide-react';
export function AIInsightCard() {
  return <div className="rounded-xl p-5 border-l-4 border-accent relative overflow-hidden mt-8 mb-8 md:mb-0" style={{
    borderLeftColor: 'var(--accent-color)',
    backgroundColor: 'color-mix(in srgb, var(--accent-color) 5%, white)'
  }} data-id="element-35">
      <div className="flex items-start gap-4" data-id="element-36">
        <div className="p-2 rounded-lg bg-white soft-shadow flex-shrink-0" data-id="element-37">
          <Lightbulb className="w-5 h-5 text-accent" style={{
          color: 'var(--accent-color)'
        }} data-id="element-38" />
        </div>
        <div data-id="element-39">
          <h3 className="text-sm font-bold text-gray-900 mb-1" data-id="element-40">AI Insight</h3>
          <p className="text-sm text-gray-700 leading-relaxed" data-id="element-41">
            <span className="font-semibold" data-id="element-42">Thaai Kizhavi</span> is dominating
            today with 22 shows across all 7 screens — 4 already HOUSEFULL.
            Evening 5 PM and 8 PM slots on Screen 1 and Screen 7 are projected
            to sell out within the hour. Consider dynamic pricing for remaining
            premium seats. Estimated uplift:{' '}
            <span className="font-semibold text-gray-900" data-id="element-43">₹1,85,000</span>.{' '}
            <span className="font-semibold" data-id="element-44">With Love</span> is steady at 65%
            avg occupancy across 6 shows — a reliable mid-tier performer.
          </p>
        </div>
      </div>
    </div>;
}